module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2022/polkolonie/big/7-598f24c58ca5e975484291ca2b4c2e74.webp";